export const agreedToCookiesScriptConsent = useScriptTriggerConsent();
